import { render, staticRenderFns } from "./writeDemo.vue?vue&type=template&id=65bb19f6&scoped=true"
import script from "./writeDemo.vue?vue&type=script&lang=js"
export * from "./writeDemo.vue?vue&type=script&lang=js"
import style0 from "./writeDemo.vue?vue&type=style&index=0&id=65bb19f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb19f6",
  null
  
)

export default component.exports